import shop from '~/lib/api/shop';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default function getDeliveryOptions(reference: string | undefined, deliveryId: number) {
    if (!reference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    return shop.get(getUrl(`/baskets/deliverydays/${reference}/${deliveryId}`)).json<string[]>();
}
